;(function () {

"use strict";

var PageView = Backbone.View.extend({
  initialize: function () {
    window.Buttons = {
      secondary: {
        label: "Write us a Review",
        href: "https://apps.shopify.com/metafields-manager?reveal_new_review=true",
        target: "new"
      }
    };
  }
});

module.exports = PageView;

}());